'use client';

import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface MetricCardProps {
    title: React.ReactNode;
    description?: string;
    className?: string;
    isLoading?: boolean;
    dynamicHeight?: boolean;
    headerAction?: React.ReactNode;
    children: React.ReactNode;
}

function ChartSkeleton() {
    return (
        <div className="h-full w-full flex flex-col justify-end gap-2 p-4">
            <div className="flex items-end justify-between h-full gap-2">
                <Skeleton className="w-full h-[60%]" />
                <Skeleton className="w-full h-[80%]" />
                <Skeleton className="w-full h-[45%]" />
                <Skeleton className="w-full h-[90%]" />
                <Skeleton className="w-full h-[70%]" />
                <Skeleton className="w-full h-[55%]" />
                <Skeleton className="w-full h-[85%]" />
            </div>
            <div className="flex items-center justify-between mt-2">
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-3 w-16" />
            </div>
        </div>
    );
}

export function MetricCard({ title, description, className = '', isLoading, dynamicHeight, headerAction, children }: MetricCardProps) {
    return (
        <Card className={className}>
            <CardHeader>
                <div className="flex items-center justify-between">
                    <CardTitle>{title}</CardTitle>
                    {headerAction}
                </div>
                {description && (
                    <CardDescription>{description}</CardDescription>
                )}
            </CardHeader>
            <CardContent className={dynamicHeight ? '' : 'h-64'}>
                {isLoading ? (
                    <ChartSkeleton />
                ) : (
                    children
                )}
            </CardContent>
        </Card>
    );
}


